// extracted by mini-css-extract-plugin
export default {"ModalTitle":"modal_ModalTitle__n65eN","ModalContent":"modal_ModalContent__Z2spf"};